<template>
	<div id="Confirm">
		<button data-bs-toggle="modal" data-bs-target="#confirmModal" v-show="false" ref="showConfirmModal" @click="setConfirm">abrir</button>
		<div class="modal fade" tabindex="-1" role="dialog" id="confirmModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content rounded-3 shadow">
				<div class="modal-body p-4 text-center">
					<h5 class="mb-0">{{ confirm.title }}</h5>
					<p class="mb-0">{{ confirm.msg }}</p>
				</div>
				<div class="modal-footer flex-nowrap p-0">
					<button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 m-0 rounded-0 border-end" @click="actionYes"><strong>{{ confirm.buttonYes }}</strong></button>
					<button type="button" class="btn btn-lg btn-link fs-6 text-decoration-none col-6 m-0 rounded-0" data-bs-dismiss="modal" @click="actionNo" ref="closeConfirmModal">{{ confirm.buttonNo }}</button>
				</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	export default {
	name: 'Confirm',
	props: ['title', 'msg', 'data'],
	data () {
		return {
			confirm: {
				title: this.title,
				msg: this.msg,
				buttonYes: 'Si, adelante',
				buttonNo: 'Cancelar'
			}
		}
	},
	computed: {
	},
	methods: {
		actionYes() {
			this.$emit('actionYes', this.data)
		},
		actionNo() {
			this.$emit('actionNo', this.data)
		},
		setConfirm() {
			this.confirm.msg = this.msg
		}
	}
}</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
